import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import NewFlightRatesResult from './NewFlightsRateResult'
import { updateStoredSearch, updatequeryid } from '../../store/Newsearchform/Newsearchform'
import { newqueries } from '../../store/Newsearchform/Newqueries'
import { getQuery } from '../../store/SearchRates/SearchRatesSlice'
import { buildAirSearchPayload } from '../../utils/openQueryResults'
import { ManageSocketContext } from '../../ManageSocketContext'
import { SkeletonCards } from './Newrateslist/Newratelisting'
import ShipRatesResult from './ShipRatesResult'
import { Modal, message } from 'antd'
const NewSearchRatesResults = () => {
    const state = useSelector(updateStoredSearch);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams()

    const { newsearchformdata } = state?.payload?.newsearchform

    // Deep link from the "Your Freight Quotation is Ready" email:
    // `/search-rates/search-rates-result?queryId=<id>`. Every other route into
    // this page is a PUSH — Queries.jsx / NewsearchForm fill
    // `newsearchformdata` in redux and only then navigate — so arriving with
    // just a URL leaves this page with an empty store and nothing to render.
    // Fetch the saved query and seed redux with the SAME payload those callers
    // build (buildAirSearchPayload); Newratelisting then fires
    // /ratesearch/all off it on mount exactly as usual.
    const deepLinkQueryId = searchParams.get('queryId')
    // Compared against the STORED query rather than just "is the store empty":
    // opening the link in a tab that already ran a search would otherwise show
    // that older search's rates and silently ignore the id in the URL.
    const storedQueryId = newsearchformdata?.searchquery?._id
    const needsBootstrap =
        !!deepLinkQueryId && String(storedQueryId || '') !== String(deepLinkQueryId)
    const [bootstrapping, setBootstrapping] = useState(needsBootstrap)
    const bootstrappedIdRef = useRef(null)
    const { setReceivingResponse } = useContext(ManageSocketContext) || {}

    useEffect(() => {
        if (!needsBootstrap) return
        // StrictMode double-invoke / re-render guard: fetch once per id.
        if (bootstrappedIdRef.current === deepLinkQueryId) return
        bootstrappedIdRef.current = deepLinkQueryId
        setBootstrapping(true)
        // Same reset Queries.jsx does before handing a query to this page, so
        // socket rows from a previous search can't bleed into this one.
        if (typeof setReceivingResponse === 'function') setReceivingResponse(null)
        let active = true
        dispatch(getQuery({ queryId: deepLinkQueryId }))
            .then((res) => {
                if (!active) return
                // get-query returns the raw Query document at `data.data` — the
                // same field set the booking-history row carries (originPort,
                // destinationPort, goodsDetails, packagingDetails, paymentTerms,
                // Quote_status, iataCass, queryExpiryDate).
                const doc = res?.payload?.data?.data
                if (!doc) {
                    setBootstrapping(false)
                    message.error(
                        "We couldn't open this quotation. Please open it from the Queries page."
                    )
                    return
                }
                dispatch(newqueries(doc))
                dispatch(updatequeryid(doc?._id || deepLinkQueryId))
                dispatch(updateStoredSearch({ nodeData: buildAirSearchPayload(doc) }))
                setBootstrapping(false)
            })
            .catch(() => {
                if (active) setBootstrapping(false)
            })
        return () => {
            active = false
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needsBootstrap, deepLinkQueryId])

    let search = newsearchformdata
    if (newsearchformdata?.searchquery?.cargoType != "Air Cargo" && newsearchformdata?.Quote_status ==
        "Quote Pending") {
        search = { "searchquery": { ...newsearchformdata, "originAirport": { ...newsearchformdata?.originPort }, "destinationAirport": { ...newsearchformdata?.destinationPort } } }
    }
    //   console.log(search,'search')

    // Deep link still resolving: hold the page rather than mounting
    // Newratelisting against an empty store. Uses Newratelisting's OWN skeleton
    // so the query fetch and the rate search that follows it read as one
    // continuous load, not two different spinners handing over.
    if (bootstrapping) {
        return (
            <div className="p-4">
                <div
                    className="listingbookked"
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        border: '1px solid #f0ede8',
                        padding: '12px 12px',
                    }}
                >
                    <SkeletonCards count={6} />
                </div>
            </div>
        )
    }

    return (
        <>

            {
                (newsearchformdata?.searchquery?.cargoType === "Air Cargo" || newsearchformdata?.searchquery?.Quote_status ==
                    "Quote Pending" || (newsearchformdata?.searchquery && Object.keys(newsearchformdata.searchquery).length > 0)) &&
                <NewFlightRatesResult nodeData={search} />
            }
        </>
    )
}

export default NewSearchRatesResults
